import React, { Component } from 'react';
import axios from 'axios';
import { Breadcrumb, Heading } from '../common/atoms';
import { Tabbar } from '../common/molecules';
import { utilizationApi } from '../../services';
import { handleAppError } from '../handlers';
import { HealthCoachLocked, HealthCoachLow } from '../../assets/images';
import { ContractsManager } from '../../managers';
import { UtilizationLockScreen, LowUtilizationCard } from '../common/organisms';
import { HEALTH_COACH_LOCKED_CONTENT, HEALTH_COACH_LOW } from '../../constants/utilization';
import {HealthCoachPrograms} from '../common/templates/Utilization';
let token = '';

class HealthCoachPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      metricObj: {},
      medicalObj: {},
      loading: true,
      show_low_screen: false,
    };
  }

  fetchCompleteData = (contractId, startDate, endDate) => {
    token = axios.CancelToken.source();

    var promise1 = utilizationApi.healthCoachFetchMetrics({ contractId, startDate, endDate, cancelToken: token.token });
    var promise2 = utilizationApi.healthCoachFetchMedicalData({ contractId, startDate, endDate, cancelToken: token.token });

    Promise.all([promise1, promise2])
      .then((values) => {
        var resp_arr = values.map((resp) => resp.data);
        var metricObj = resp_arr[0];
        var medicalObj = resp_arr[1];
        var show_low_screen = metricObj.total_enrollment < 10;

        this.setState({ metricObj, medicalObj, loading: false, show_low_screen });
      })
      .catch((err) => handleAppError(err));
  };

  fetchContractDetails = () => {
    utilizationApi.fetchContracts(
      {},
      (resp) => {
        var contractObj = new ContractsManager(resp.data);
        this.setState({
          contractObj,
          selectedContractObj: contractObj.formattedData[0],
          contractId: contractObj.formattedData[0].contract_id,
          startDate: contractObj.formattedData[0].start_date,
          endDate: contractObj.formattedData[0].end_date,
          totalCustomers: contractObj.formattedData[0].total_customers,
        });
      },
      (err) => {
        handleAppError(err);
      }
    );
  };

  componentDidMount() {
    this.fetchContractDetails();
  }

  componentWillUnmount() {
    token && token.cancel();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.contractId && prevState.contractId !== this.state.contractId) {
      token && token.cancel();
      this.fetchCompleteData(this.state.contractId, this.state.startDate, this.state.endDate);
    }
  }

  toggleHelp = () => this.props.toggleHelp('Health_Coach');

  content = (selectedContractObj) => {
    const { loading, show_low_screen } = this.state;

    if (loading || selectedContractObj.enable_health_coach) {
      return show_low_screen ? (
        <LowUtilizationCard
          {...HEALTH_COACH_LOW}
          imgsrc={HealthCoachLow}
          toggleHelp={this.toggleHelp}
          sponsored={true}
          classes='mt-8'
        />
      ) : (
        <HealthCoachPrograms {...this.state} />
      );
    } else {
      return (
        <div className='mt-8'>
          <UtilizationLockScreen
            sectionTitle='Health Coach is not enabled'
            image={HealthCoachLocked}
            sectionSubtitle='Benefits to your employees'
            points={HEALTH_COACH_LOCKED_CONTENT}
            toggleHelp={this.toggleHelp}
          />
        </div>
      );
    }
  };

  changeContractId = (contract) => {
    const { contractId } = this.state;
    const { contract_id, start_date, end_date } = contract;
    if (contract_id && contractId !== contract_id) {
      this.setState({
        contractId: contract_id,
        startDate: start_date,
        endDate: end_date,
        selectedContractObj: contract,
        metricObj: {},
        ratingObj: {},
        costSavingObj: {},
        utilizationObj: {},
        loading: true,
        show_low_screen: false,
      });
    }
  };

  navigateToActivityLog = () => {
    const { start_date, end_date } = this.state.contractObj.data[0];
    this.props.history.push('/activity-log?point=health_coach', { start_date, end_date });
  };

  render() {
    const { contractObj, loading } = this.state;
    const formattedData = contractObj ? contractObj.formattedData : null;

    return (
      <React.Fragment>
        <Breadcrumb
          list={[
            { text: 'Utilization', link: '/health-checks' },
            { text: 'Health Coach', link: '/health-coach-programs' },
          ]}
          classes='mb-1'
        />
        <div className='flex flex-row justify-between'>
          {typeof this.state.selectedContractObj !== 'undefined' && (
            <Heading
              mainHeading='Utilization of Health Coach'
            />
          )}
          {/* <button
            type='submit'
            onClick={this.navigateToActivityLog}
            className='block rounded border border-transparent bg-blue-500 text-base font-semibold text-white focus:outline-none px-5'
          >
            Activity Log
          </button> */}
        </div>

        <Tabbar
          loading={loading}
          list={formattedData}
          classes='mt-5'
          currentPage={formattedData ? formattedData[0].text : null}
          setContract={this.changeContractId}
        />
        {this.content(this.state.selectedContractObj)}
      </React.Fragment>
    );
  }
}

export default HealthCoachPage;
